import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Heading, Paragraph } from '@digdir/designsystemet-react';

import { SimpleEnergyAnalysis } from '../../../types/building';
import { initRegistration } from '../../../store/registration/actions';

import { Tilstand } from './tilstand';
import { Actions, TintedCard } from './styledComponents';

interface Props {
  energyAnalysis?: SimpleEnergyAnalysis;
}

export const Fortilstand: FC<Props> = ({ energyAnalysis }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const initAndNavigateToNewSoknad = () => {
    dispatch(initRegistration());
    navigate(`/registrer-energimerke/ny-energiplan/${params.buildingId}`, { state: { returnTo: location.pathname } });
  };

  const energiplan = energyAnalysis?.energiplan;

  if (!energiplan) {
    return (
      <TintedCard>
        <Heading data-size="sm">{t('screens.energiplan.components.emptyState.heading')}</Heading>
        <Paragraph>{t('screens.energiplan.components.emptyState.description')}</Paragraph>
        <Actions>
          <Button onClick={initAndNavigateToNewSoknad}>
            {t('screens.energiplan.components.emptyState.createButton')}
          </Button>
          <Button variant="secondary">{t('screens.energiplan.components.emptyState.useExistingButton')}</Button>
        </Actions>
      </TintedCard>
    );
  }

  return <Tilstand title={t('screens.energiplan.components.fortilstand.title')} energiplan={energiplan} />;
};
